
import React from "react";
import { Admin, Resource } from "react-admin";

import dataProvider from "../api/dataProvider";
import CustomAdminLayout from "./CustomAdminLayout";

import { UserList, UserCreate, UserEdit } from "./users/Users";
import { UserProfileList, UserProfileEdit } from "./users/UserProfiles";
import { OrganizationList, OrganizationCreate, OrganizationEdit } from "./users/Organizations";
import {
    GovernmentInstitutionList,
    GovernmentInstitutionCreate,
    GovernmentInstitutionEdit
} from "./users/GovernmentInstitutions";

export default function AdminPageManager() {
    return (
        <Admin
            basename="/manager"
            dataProvider={dataProvider}
            layout={CustomAdminLayout}
        >
            <Resource
                name="users/users"
                list={UserList}
                create={UserCreate}
                edit={UserEdit}
                options={{ label: "Пользователи" }}
            />
            <Resource
                name="users/user-profiles"
                list={UserProfileList}
                edit={UserProfileEdit}
                options={{ label: "Профили польз-лей" }}
            />
            <Resource
                name="users/organizations"
                list={OrganizationList}
                create={OrganizationCreate}
                edit={OrganizationEdit}
                options={{ label: "Организации" }}
            />
            <Resource
                name="users/government-institutions"
                list={GovernmentInstitutionList}
                create={GovernmentInstitutionCreate}
                edit={GovernmentInstitutionEdit}
                options={{ label: "Гос учреждения" }}
            />
        </Admin>
    );
}